/**
 * Whether the audio is a music platform's ~30s clip rather than a full podcast
 * episode. A whitelist, because the failure modes aren't symmetric: an unrecognised
 * music clip still stops on its own (the file IS 30s), while mistaking a podcast for a
 * clip cuts a 48-minute episode off at 30s.
 */

/** Exact host, or a parent domain when prefixed with a dot. */
const kMusicPreviewHosts = [
  'p.scdn.co',
  'audio-ssl.itunes.apple.com',
  'audio.itunes.apple.com',
  '.dzcdn.net',
];

export function isMusicPreviewClip(audioUrl: string | undefined): boolean {
  if (!audioUrl) return false;
  let host: string;
  try {
    host = new URL(audioUrl).hostname.toLowerCase();
  } catch {
    return false;
  }
  return kMusicPreviewHosts.some(previewHost =>
    previewHost.startsWith('.')
      ? host.endsWith(previewHost)
      : host === previewHost,
  );
}
